export const SuperAdminConstants = {

    REQUEST_COMBINED_DENY_METRIC: 'REQUEST_COMBINED_DENY_METRIC',
    RECEIVE_COMBINED_DENY_METRIC: 'RECEIVE_COMBINED_DENY_METRIC',
    COMBINED_DENY_METRIC_ERROR: 'COMBINED_DENY_METRIC_ERROR',

    REQUEST_COMBINED_ALLOW_METRIC: 'REQUEST_COMBINED_ALLOW_METRIC',
    RECEIVE_COMBINED_ALLOW_METRIC: 'RECEIVE_COMBINED_ALLOW_METRIC',
    COMBINED_ALLOW_METRIC_ERROR: 'COMBINED_ALLOW_METRIC_ERROR',

    REQUEST_COMBINED_METRIC_LIST: 'REQUEST_COMBINED_METRIC_LIST',
    RECEIVE_COMBINED_METRIC_LIST: 'RECEIVE_COMBINED_METRIC_LIST',
    COMBINED_METRIC_LIST_ERROR: 'COMBINED_METRIC_LIST_ERROR',

    REQUEST_DEFAULT_METRIC_LIST: 'REQUEST_DEFAULT_METRIC_LIST',
    RECEIVE_DEFAULT_METRIC_LIST: 'RECEIVE_DEFAULT_METRIC_LIST',
    DEFAULT_METRIC_LIST_ERROR: 'DEFAULT_METRIC_LIST_ERROR',

    REQUEST_DELETE_EXISTING_METRIC: 'REQUEST_DELETE_EXISTING_METRIC',
    RECEIVE_DELETE_EXISTING_METRIC: 'RECEIVE_DELETE_EXISTING_METRIC',
    DELETE_EXISTING_METRIC_ERROR: 'DELETE_EXISTING_METRIC_ERROR',

    REQUEST_EDIT_EXISTING_METRIC: 'REQUEST_EDIT_EXISTING_METRIC',
    RECEIVE_EDIT_EXISTING_METRIC: 'RECEIVE_EDIT_EXISTING_METRIC',
    EDIT_EXISTING_METRIC_ERROR: 'EDIT_EXISTING_METRIC_ERROR',

    REQUEST_ADD_NEW_METRIC: 'REQUEST_ADD_NEW_METRIC',
    RECEIVE_ADD_NEW_METRIC: 'RECEIVE_ADD_NEW_METRIC',
    ADD_NEW_METRIC_ERROR: 'ADD_NEW_METRIC_ERROR',

    REQUEST_ANALYTICS_DEFAULT_METRIC_LIST: 'REQUEST_ANALYTICS_DEFAULT_METRIC_LIST',
    RECEIVE_ANALYTICS_DEFAULT_METRIC_LIST: 'RECEIVE_ANALYTICS_DEFAULT_METRIC_LIST',
    ANALYTICS_DEFAULT_METRIC_LIST_ERROR: 'ANALYTICS_DEFAULT_METRIC_LIST_ERROR',

    REQUEST_ASSESSOR_GROUP_LIST_ASSIGN: 'REQUEST_ASSESSOR_GROUP_LIST_ASSIGN',
    RECEIVE_ASSESSOR_GROUP_LIST_ASSIGN: 'RECEIVE_ASSESSOR_GROUP_LIST_ASSIGN',
    ASSESSOR_GROUP_LIST_ASSIGN_ERROR: 'ASSESSOR_GROUP_LIST_ASSIGN_ERROR',

    REQUEST_POST_ASSESSOR_GROUP_LIST: 'REQUEST_POST_ASSESSOR_GROUP_LIST',
    RECEIVE_POST_ASSESSOR_GROUP_LIST: 'RECEIVE_POST_ASSESSOR_GROUP_LIST',
    POST_ASSESSOR_GROUP_LIST_ERROR: 'POST_ASSESSOR_GROUP_LIST_ERROR',

    REQUEST_GET_ASSESSOR_GROUP_LIST: 'REQUEST_GET_ASSESSOR_GROUP_LIST',
    RECEIVE_GET_ASSESSOR_GROUP_LIST: 'RECEIVE_GET_ASSESSOR_GROUP_LIST',
    GET_ASSESSOR_GROUP_LIST_ERROR: 'GET_ASSESSOR_GROUP_LIST_ERROR',

    REQUEST_DELETE_ASSIGN_ASSESSOR: 'REQUEST_DELETE_ASSIGN_ASSESSOR',
    RECEIVE_DELETE_ASSIGN_ASSESSOR: 'RECEIVE_DELETE_ASSIGN_ASSESSOR',
    DELETE_ASSIGN_ASSESSOR_ERROR: 'DELETE_ASSIGN_ASSESSOR_ERROR',

    REQUEST_GET_ORG_DETAILS: 'REQUEST_GET_ORG_DETAILS',
    RECEIVE_GET_ORG_DETAILS: 'RECEIVE_GET_ORG_DETAILS',
    GET_ORG_DETAILS_ERROR: 'GET_ORG_DETAILS_ERROR',

    REQUEST_EDIT_ORG_DETAILS: 'REQUEST_EDIT_ORG_DETAILS',
    RECEIVE_EDIT_ORG_DETAILS: 'RECEIVE_EDIT_ORG_DETAILS',
    EDIT_ORG_DETAILS_ERROR: 'EDIT_ORG_DETAILS_ERROR',

    REQUEST_DELETE_ORG_DETAILS: 'REQUEST_DELETE_ORG_DETAILS',
    RECEIVE_DELETE_ORG_DETAILS: 'RECEIVE_DELETE_ORG_DETAILS',
    DELETE_ORG_DETAILS_ERROR: 'DELETE_ORG_DETAILS_ERROR',

    REQUEST_GET_ASSESSMENT_ORGANISATION: 'REQUEST_GET_ASSESSMENT_ORGANISATION',
    RECEIVE_GET_ASSESSMENT_ORGANISATION: 'RECEIVE_GET_ASSESSMENT_ORGANISATION',
    GET_ASSESSMENT_ORGANISATION_ERROR: 'GET_ASSESSMENT_ORGANISATION_ERROR',

    REQUEST_GET_ANALYTICS_ORGANISATION: 'REQUEST_GET_ANALYTICS_ORGANISATION',
    RECEIVE_GET_ANALYTICS_ORGANISATION: 'RECEIVE_GET_ANALYTICS_ORGANISATION',
    GET_ANALYTICS_ORGANISATION_ERROR: 'GET_ANALYTICS_ORGANISATION_ERROR',

    REQUEST_ADD_ASSESSMENT_ORGANISATION: 'REQUEST_ADD_ASSESSMENT_ORGANISATION',
    RECEIVE_ADD_ASSESSMENT_ORGANISATION: 'RECEIVE_ADD_ASSESSMENT_ORGANISATION',
    ADD_ASSESSMENT_ORGANISATION_ERROR: 'ADD_ASSESSMENT_ORGANISATION_ERROR',

    REQUEST_REMOVE_ASSESSMENT_ORGANISATION: 'REQUEST_REMOVE_ASSESSMENT_ORGANISATION',
    RECEIVE_REMOVE_ASSESSMENT_ORGANISATION: 'RECEIVE_REMOVE_ASSESSMENT_ORGANISATION',
    REMOVE_ASSESSMENT_ORGANISATION_ERROR: 'REMOVE_ASSESSMENT_ORGANISATION_ERROR',

    REQUEST_ANALYTICS_ORG_BATCHES: 'REQUEST_ANALYTICS_ORG_BATCHES',
    RECEIVE_ANALYTICS_ORG_BATCHES: 'RECEIVE_ANALYTICS_ORG_BATCHES',
    ANALYTICS_ORG_BATCHES_ERROR: 'ANALYTICS_ORG_BATCHES_ERROR',

    REQUEST_ADD_ANALYTICS_ACTIVE_BATCHES: 'REQUEST_ADD_ANALYTICS_ACTIVE_BATCHES',
    RECEIVE_ADD_ANALYTICS_ACTIVE_BATCHES: 'RECEIVE_ADD_ANALYTICS_ACTIVE_BATCHES',
    ADD_ANALYTICS_ACTIVE_BATCHES_ERROR: 'ADD_ANALYTICS_ACTIVE_BATCHES_ERROR',

    REQUEST_ANALYTICS_ACTIVE_BATCHES: 'REQUEST_ANALYTICS_ACTIVE_BATCHES',
    RECEIVE_ANALYTICS_ACTIVE_BATCHES: 'RECEIVE_ANALYTICS_ACTIVE_BATCHES',
    ANALYTICS_ACTIVE_BATCHES_ERROR: 'ANALYTICS_ACTIVE_BATCHES_ERROR',

    REQUEST_REMOVE_ANALYTICS_ACTIVE_BATCHES: 'REQUEST_REMOVE_ANALYTICS_ACTIVE_BATCHES',
    RECEIVE_REMOVE_ANALYTICS_ACTIVE_BATCHES: 'RECEIVE_REMOVE_ANALYTICS_ACTIVE_BATCHES',
    REMOVE_ANALYTICS_ACTIVE_BATCHES_ERROR: 'REMOVE_ANALYTICS_ACTIVE_BATCHES_ERROR',

    REQUEST_GET_ORG_ADMINS: 'REQUEST_GET_ORG_ADMINS',
    RECEIVE_GET_ORG_ADMINS: 'RECEIVE_GET_ORG_ADMINS',
    GET_ORG_ADMINS_ERROR: 'GET_ORG_ADMINS_ERROR',

    REQUEST_ADD_ORG_ADMINS: 'REQUEST_ADD_ORG_ADMINS',
    RECEIVE_ADD_ORG_ADMINS: 'RECEIVE_ADD_ORG_ADMINS',
    ADD_ORG_ADMINS_ERROR: 'ADD_ORG_ADMINS_ERROR',

    REQUEST_MAKE_ORG_PRIMARY_ADMIN: 'REQUEST_MAKE_ORG_PRIMARY_ADMIN',
    RECEIVE_MAKE_ORG_PRIMARY_ADMIN: 'RECEIVE_MAKE_ORG_PRIMARY_ADMIN',
    MAKE_ORG_PRIMARY_ADMIN_ERROR: 'MAKE_ORG_PRIMARY_ADMIN_ERROR',

    REQUEST_REMOVE_ORG_ADMIN: 'REQUEST_REMOVE_ORG_ADMIN',
    RECEIVE_REMOVE_ORG_ADMIN: 'RECEIVE_REMOVE_ORG_ADMIN',
    REMOVE_ORG_ADMIN_ERROR: 'REMOVE_ORG_ADMIN_ERROR',

    REQUEST_GET_CREDITS: 'REQUEST_GET_CREDITS',
    RECEIVE_GET_CREDITS: 'RECEIVE_GET_CREDITS',
    GET_CREDITS_ERROR: 'GET_CREDITS_ERROR',

    REQUEST_ADD_CREDITS: 'REQUEST_ADD_CREDITS',
    RECEIVE_ADD_CREDITS: 'RECEIVE_ADD_CREDITS',
    ADD_CREDITS_ERROR: 'ADD_CREDITS_ERROR',

    REQUEST_REVOKE_CREDITS: 'REQUEST_REVOKE_CREDITS',
    RECEIVE_REVOKE_CREDITS: 'RECEIVE_REVOKE_CREDITS',
    REVOKE_CREDITS_ERROR: 'REVOKE_CREDITS_ERROR',

    REQUEST_GET_METRICS_LIST: 'REQUEST_GET_METRICS_LIST',
    RECEIVE_GET_METRICS_LIST: 'RECEIVE_GET_METRICS_LIST',
    GET_METRICS_LIST_ERROR: 'GET_METRICS_LIST_ERROR',

    REQUEST_GET_ANALYTICS_METRICS_LIST:'REQUEST_GET_ANALYTICS_METRICS_LIST',
    RECEIVE_GET_ANALYTICS_METRICS_LIST: 'RECEIVE_GET_ANALYTICS_METRICS_LIST',
    GET_ANALYTICS_METRICS_LIST_ERROR: 'GET_ANALYTICS_METRICS_LIST_ERROR',

    REQUEST_METRIC_CHANGE_ACCESS:'REQUEST_METRIC_CHANGE_ACCESS',
    RECEIVE_METRIC_CHANGE_ACCESS:'RECEIVE_METRIC_CHANGE_ACCESS',
    METRIC_CHANGE_ACCESS_ERROR:'METRIC_CHANGE_ACCESS_ERROR',

    REQUEST_EDIT_METRICS: 'REQUEST_EDIT_METRICS',
    RECEIVE_EDIT_METRICS: 'RECEIVE_EDIT_METRICS',
    EDIT_METRICS_ERROR: 'EDIT_METRICS_ERROR',

    REQUEST_DELETE_METRICS: 'REQUEST_DELETE_METRICS',
    RECEIVE_DELETE_METRICS: 'RECEIVE_DELETE_METRICS',
    DELETE_METRICS_ERROR: 'DELETE_METRICS_ERROR',

    REQUEST_ASSIGN_METRIC: 'REQUEST_ASSIGN_METRIC',
    RECEIVE_ASSIGN_METRIC: 'RECEIVE_ASSIGN_METRIC',
    ASSIGN_METRIC_ERROR: 'ASSIGN_METRIC_ERROR',

    REQUEST_EDIT_ASSIGN_METRICS: 'REQUEST_EDIT_ASSIGN_METRICS',
    RECEIVE_EDIT_ASSIGN_METRICS: 'RECEIVE_EDIT_ASSIGN_METRICS',
    EDIT_ASSIGN_METRICS_ERROR: 'EDIT_ASSIGN_METRICS_ERROR',

    REQUEST_DELETE_ASSIGN_METRICS: 'REQUEST_DELETE_ASSIGN_METRICS',
    RECEIVE_DELETE_ASSIGN_METRICS: 'RECEIVE_DELETE_ASSIGN_METRICS',
    DELETE_ASSIGN_METRICS_ERROR: 'DELETE_ASSIGN_METRICS_ERROR',

    REQUEST_GET_SWOT_TEXT: 'REQUEST_GET_SWOT_TEXT',
    RECEIVE_GET_SWOT_TEXT: 'RECEIVE_GET_SWOT_TEXT',
    GET_SWOT_TEXT_ERROR: 'GET_SWOT_TEXT_ERROR',

    REQUEST_EDIT_SWOT_TEXT: 'REQUEST_EDIT_SWOT_TEXT',
    RECEIVE_EDIT_SWOT_TEXT: 'RECEIVE_EDIT_SWOT_TEXT',
    EDIT_SWOT_TEXT_ERROR: 'EDIT_SWOT_TEXT_ERROR',

    REQUEST_GET_FOCUS_AREA_TEXT: 'REQUEST_GET_FOCUS_AREA_TEXT',
    RECEIVE_GET_FOCUS_AREA_TEXT: 'RECEIVE_GET_FOCUS_AREA_TEXT',
    GET_FOCUS_AREA_TEXT_ERROR: 'GET_FOCUS_AREA_TEXT_ERROR',

    REQUEST_EDIT_FOCUS_AREA_TEXT: 'REQUEST_EDIT_FOCUS_AREA_TEXT',
    RECEIVE_EDIT_FOCUS_AREA_TEXT: 'RECEIVE_EDIT_FOCUS_AREA_TEXT',
    EDIT_FOCUS_AREA_TEXT_ERROR: 'EDIT_FOCUS_AREA_TEXT_ERROR',

    REQUEST_GET_REVIEW_QUESTIONS: 'REQUEST_GET_REVIEW_QUESTIONS',
    RECEIVE_GET_REVIEW_QUESTIONS: 'RECEIVE_GET_REVIEW_QUESTIONS',
    GET_REVIEW_QUESTIONS_ERROR: 'GET_REVIEW_QUESTIONS_ERROR',

    REQUEST_EDIT_REVIEW_QUESTIONS: 'REQUEST_EDIT_REVIEW_QUESTIONS',
    RECEIVE_EDIT_REVIEW_QUESTIONS: 'RECEIVE_EDIT_REVIEW_QUESTIONS',
    EDIT_REVIEW_QUESTIONS_ERROR: 'EDIT_REVIEW_QUESTIONS_ERROR',

};



// WEBPACK FOOTER //
// ./src/_constants/SuperAdmin/superAdmin.constants.js